import { render, staticRenderFns } from "./TableMobileOPComponentGlobal.vue?vue&type=template&id=72e51670&"
import script from "./TableMobileOPComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./TableMobileOPComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TableMobileOPComponentGlobal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VDivider,VProgressLinear})
